import { getUserObject, assortments } from "utils/relewise";

interface Params {
  products: {
    variantId?: string;
    productId: string;
  }[];
  cartSTLIds: string[];
  cartItemIds: string[];
  vendor?: string;
}

export default function getCartRecommendationsObject(options: Params) {
  return {
    productAndVariantIds: options.products,
    Settings: {
      NumberOfRecommendations: 12,
      AllowFillIfNecessaryToReachNumberOfRecommendations: true,
      AllowReplacingOfRecentlyShownRecommendations: false,
      RecommendVariant: true,
      SelectedProductProperties: {
        DisplayName: true,
        Pricing: true,
      },
      SelectedVariantProperties: {
        DisplayName: true,
        Pricing: true,
        DataKeys: ["COM_ShopifyHandle", "DE_ShopifyHandle", "DK_ShopifyHandle", "SE_ShopifyHandle", "UK_ShopifyHandle", "NO_ShopifyHandle", "ImageUrls"],
      },
    },
    RelevanceModifiers: {
      Items: [
        {
          $type: "Relewise.Client.Requests.RelevanceModifiers.ProductIdRelevanceModifier, Relewise.Client",
          ProductIds: options.cartItemIds,
          MultiplyWeightBy: 5000.0,
          Negated: false,
          TypeName: "ProductIdRelevanceModifier",
        },
        {
          $type: "Relewise.Client.Requests.RelevanceModifiers.VariantDataRelevanceModifier, Relewise.Client",
          Key: "ShopTheLook",
          ConsiderAsMatchIfKeyIsNotFound: false,
          MultiplyWeightBy: 0.0,
          MustMatchAllConditions: true,
          Conditions: [
            {
              $type: "Relewise.Client.Requests.Conditions.ContainsCondition, Relewise.Client",
              Value: {
                Type: "StringList",
                Value: {
                  $type:
                    "System.Collections.Generic.List`1[[System.String, System.Private.CoreLib]], System.Private.CoreLib",
                  $values: options.cartSTLIds,
                },
                IsCollection: true,
              },
              ValueCollectionEvaluationMode: "All",
              TypeName: "ContainsCondition",
              Negated: false,
            },
          ],
          MultiplierSelector: {
            $type: "Relewise.Client.Requests.ValueSelectors.FixedDoubleValueSelector, Relewise.Client",
            Value: 5000.0,
          },
          TypeName: "VariantDataRelevanceModifier",
        },
      ],
    },
    Filters: {
      Items: [
        ...(options.vendor ? [
          {
            $type:
              "Relewise.Client.Requests.Filters.ProductDataFilter, Relewise.Client",
            Key: "Vendor",
            FilterOutIfKeyIsNotFound: true,
            MustMatchAllConditions: true,
            Conditions: {
              Items: [
                {
                  $type:
                    "Relewise.Client.Requests.Conditions.EqualsCondition, Relewise.Client",
                  Value: {
                    Value: options.vendor,
                  },
                  TypeName: "EqualsCondition",
                },
              ],
            },
            TypeName: "ProductDataFilter",
          },
        ] : []),
        {
          $type: "Relewise.Client.Requests.Filters.ProductAssortmentFilter, Relewise.Client",
          Assortments: [assortments[window.mosmosh.shop_code]],
          TypeName: "ProductAssortmentFilter",
        },
        {
          $type: "Relewise.Client.Requests.Filters.VariantAssortmentFilter, Relewise.Client",
          Assortments: [assortments[window.mosmosh.shop_code]],
          TypeName: "VariantAssortmentFilter",
        },
      ],
    },
    Language: {
      Value: window.mosmosh.shop_local.iso,
    },
    User: getUserObject(),
    DisplayedAtLocationType: "Cart recommendations",
  };
}
